// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__UAL52","list":"styles_list__wiM7g","verticalList":"styles_verticalList__nUmgO"};